import fetch from '@/utils/fetch'

// 密码登录
export function login(username, password) {
  return fetch({
    url: '/yaf_sys/sys/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
// 登录
export function loginVerify(mobile, verifycode) {
    return fetch({
      url: '/yaf_sys/sys/login_verify',
      method: 'post',
      params: {
        verifycode: verifycode,
        mobile: mobile
      }
    })
}
// 发送校验码
export function sendVerify(mobile) {
    return fetch({
      url: '/yaf_sys/account/sendverify',
      method: 'get',
      params: { 'mobile': mobile }
    })
  }
//   注册
export function register(verifycode, accountEnrity) {
    return fetch({
      url: '/yaf_sys/account/register/' + verifycode,
      method: 'post',
      data: accountEnrity
    })
}
// 备用
export function changeCompany(companyId) {
    return fetch({
      url: '/yaf_sys/sys/change',
      method: 'get',
      params: { companyId }
    })
  }

export function getInfo() {
    return fetch({
        url: '/yaf_sys/sys/userinfo',
        method: 'get'
    })
}

export function logout() {
    return fetch({
        url: '/yaf_sys/sys/logout',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js